module.exports = __webpack_public_path__ + "img/DE01279.8a62767c.png";